module.exports = "/images/hurricane-force-wind@3x.png?fb0aac9ff024fa701e530b1a24a4d042";